import { Injectable, NgZone } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

import { AuthService } from './auth.service';
import { User } from '../models/user';
import { takeWhile } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private user: ReplaySubject<any> = new ReplaySubject<any>();
  public user$: Observable<any> = this.user.asObservable();
  public authProfile = null;
public userProfile:User = null;
  private fetchInProgress = false;


  constructor(
    private readonly authService: AuthService,
    private readonly ngZone: NgZone
  ) {}

  public getCurrentUser() {
    if (this.authProfile !== null || this.fetchInProgress) {
      return;
    }
    this.fetchInProgress = true;
    this.authService
      .getUser$()
      .pipe(takeWhile(() => this.authProfile === null))
      .subscribe((authProfile) => {
        this.fetchInProgress = false;
        if (!authProfile) {
          return;
        }
        if (authProfile) {
          this.authProfile = authProfile;

          const isInternal = Boolean(
            authProfile['http://allegion.com/claims/user_type'] === 'internal'
          );
          const userMetadata =
            authProfile['http://allegion.com/claims/user_metadata'];
          
          const roles=authProfile['http://allegion.com/claims/roles'];
          const curUser: User = {
            name: authProfile.name,
            email: authProfile.email,
            authId: authProfile.sub,
            roles:roles,
            initials: `${authProfile.given_name[0]}${authProfile.family_name[0]}`
          };
          this.ngZone.run(() => {
            this.user.next(curUser);
          });
        }
      });
  }
}
